import CreateEditSiteContent from "@/app/app-shared/site-content/create-edit";
import PageHeader from "@/app/shared/page-header";
import { routes } from "@/config/routes";
import useApi from "@/hooks/useApi";
import { ESiteContentType } from "@/utilities/enums/SiteContent";
import SiteContentRepository from "@/utilities/repositories/SiteContent";
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function SiteContentCrUpPage() {
  const { id } = useParams();
  const { profile } = useProfile();

  const isUpdate = !!id;

  const { request: getSiteContentById, response } = useApi({
    request: SiteContentRepository.getSiteContentById,
  });

  const title =
    response?.data?.contentType === ESiteContentType.PRIVACT_POLICY
      ? "Privacy Policy"
      : isUpdate
        ? "Edit Page"
        : "Create Page";

  const pageHeader = {
    title,
    breadcrumb: [
      {
        href: routes.siteContent.listing,
        name: "Pages",
      },
      {
        name: title,
      },
    ],
  };

  useEffect(() => {
    if (id) getSiteContentById(id);
  }, [getSiteContentById, id]);

  const renderByType = (type?: string) => {
    if (!isUpdate) {
      return <CreateEditSiteContent defaultValues={{ content: "", title: "" }} />;
    }
    if (!type) return <></>;
    if (
      type === ESiteContentType.PRIVACT_POLICY &&
      profile?.role !== Roles.ADMIN
    ) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: response?.data?.content || "",
          }}
        />
      );
    }

    return (
      <CreateEditSiteContent
        defaultValues={{
          content: response?.data?.content || "",
          title: response?.data?.title || "",
          metaTitle: response?.data?.metaTitle || "",
          metaDescription: response?.data?.metaDescription || "",
          featuredImageId: response?.data?.featuredImageId || undefined,
          featuredImageUrl: response?.data?.featuredImageUrl || "",
        }}
      />
    );
  };

  return (
    <div className="@container h-full mt-10">
      <PageHeader
        title={pageHeader.title}
        breadcrumb={pageHeader.breadcrumb}
      ></PageHeader>
      {renderByType(response?.data?.contentType)}
    </div>
  );
}
